<template>
  <span class="whitespace-no-wrap">
    <i v-if="icon" :class="icon" />
    <img v-if="image" :src="image" :alt="label" style="max-height: 1rem" />
    {{ label }}
  </span>
</template>

<script>
import ValueMixin from './ValueMixin'
import bancontact from '../../assets/images/bancontact.svg'

export default {
  name: 'ValuePaymentMethod',

  mixins: [ValueMixin],

  props: {
    attribute: { type: String, default: 'payment_method' },
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data() {
    return {
      icons: {
        card: 'icon-credit-card',
        cash: 'icon-cash3',
        on_invoice: null,
      },

      labels: this.$t('enums.payment_method'),
    }
  },

  computed: {
    icon() {
      return this.icons[this.value] || ''
    },
    image() {
      return this.value === 'bancontact' ? bancontact : null
    },
    label() {
      return this.labels[this.value] || ''
    },
  },
}
</script>
